import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Header from '../components/header';
import MobilePage from '../components/mobile';
import Footer from '../components/footer';
import '../layouts/index.css';

class Contributors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      minimumdesktop: 700,
      desktop: true,
    };
  }

  componentDidMount() {
    this.render();
    this.checkdesktop();
    window.addEventListener('resize', this.checkdesktop.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkdesktop.bind(this));
  }

  about = () => {
    return (
      <div className="about">

        <div className="textbox">
          <h1 className="textbox-heading">About the Project</h1>
        </div>

        <div className="textbox-info">
          <p id="text"> The Class of 1930 Seminar Room, located in the Rockefeller Center,
            features a wall bearing the names of alumni and alumnae who have served,
            or will serve, in national elective office or as state governors.
            Currently, 189 names are featured on the wall under the inscription
            “…to honor our classmates and those who have preceded, followed,
            and will follow them in the Dartmouth tradition of accepting the
            responsibility of public life, we recognize here those who have
            served in national elective office or as governors.”
            Thirty-five years on, this collaborative, student-led project
            seeks to make this Dartmouth tradition of service available
            online as a further source of inspiration. Starting with their
            time on campus and extending to their public service careers,
            the site embodies the accomplishments of individuals,
            the aspirations of a college, and the spirit of service to society.
          </p>
        </div>

        <div className="dartmouth-hall">
          <img id="dartmouth-hall" src={require('../assets/images/dartmouth.png')} alt="Dartmouth Hall" />
        </div>
      </div>
    );
  }

  acknowledgements = () => {
    return (
      <div>
        <div className="textbox" id="textbox-acknowledgements">
          <h1 className="textbox-heading" id="acknowledgements-heading"> Acknowledgements </h1>
        </div>
        <div className="textbox-info">
          <p id="andrew-heading">Andrew Samwick</p>
          <p id="text">
            {'"Dartmouth has a long and proud tradition of public service in high elected and appointed office. Since its founding, the Rockefeller Center has commemorated that tradition with a wall of honor in the Class of 1930 Room. Through the Public Service Legacy Project, we seek to celebrate Dartmouth’s 250th anniversary and the Rockefeller Center’s 35th anniversary by enabling everyone in the Dartmouth community to learn about these alumni, their lives at Dartmouth, and their service to the nation. We hope that future generations of students, faculty, and staff will build on this project to continue to recognize and take pride in Dartmouth alumni in public service."'}
          </p>
          <div className="andrew">
            <p id="andrew-name">Andrew Samwick</p>
            <p id="andrew-position"> Director of the Nelson A. Rockefeller Center for Public Policy and the Social Sciences,</p>
            <p id="andrew-position"> Sandra L. and Arthur L. Irving {'’72a, P’10'} Professor of Economics</p>
          </div>
        </div>
        <div className="textbox-info" id="acknowledgements-info">
          <p id="name">Lorie Loeb</p>
          <p id="text">
            {'"A challenge for DALI was designing a site that allows visitors to get a sense of the wide range of political and policy impact Dartmouth alums have had over our 250-year history, while also finding ways to dive into details about each person and their achievements. It was fabulous to have so much data to work with, which has resulted in a dynamic, online presence that highlights the long and strong history of Dartmouth\'s political impact and public policy achievements"'}
          </p>
          <div className="andrew">
            <p id="andrew-name">Lorie Loeb</p>
            <p id="andrew-position"> Professor of Computer Science,</p>
            <p id="andrew-position">Faculty Director of the DALI Lab</p>

          </div>
        </div>
      </div>
    );
  }

  contributors = () => {
    return (
      <div className="about">

        <div className="textbox" id="referencess">
          <h1 className="textbox-heading" id="acknowledgements-heading">Contributors</h1>
        </div>
        <div className="textbox-info" id="statisticians">
          <p id="stat-heading">Elizabeth Celtrick</p>
          <p id="stats">
            Senior Assistant Director of the Nelson A. Rockefeller Center for Public Policy and the Social Sciences
          </p>
        </div>
        <div className="textbox-info">
          <p id="andrew-heading">Project Managers</p>
          <p id="stats">
            <span id="class-year">Class of 2020: </span>Jiachen Jiang, Alexandrea Keith, Catherine Zhao
          </p>
          <p id="stats">
            <span id="class-year">Class of 2021: </span>Varsha Iyer
          </p>
        </div>
        <div className="textbox-info" id="statisticians">
          <p id="stat-heading">Researchers</p>
          <div className="contributors">
            <img id="rocky-250" src={require('../assets/images/circle-r.jpg')} alt="Rocky 250" />

            <div>
              <p id="stats">
                <span id="class-year">Class of 2018: </span>Estaphanie Aquino,
                Jimmy Fair, Rachel Favors, Abhi Gokulan,
                May Nguyen, Cameron Poole
              </p>
              <p id="stats">
                <span id="class-year">Class of 2019: </span>Alexis Castillo,
                Ethan Fairbanks, Makena Kauhane, Anneliese Thomas
              </p>
              <p id="stats">
                <span id="class-year">Class of 2020: </span>Lauren Archer,
                Chris Chon, Alyssa Gao, Alexandrea Keith, Jiachen Jiang,
                Allison Tong
              </p>
              <p id="stats">
                <span id="class-year">Class of 2021: </span>Dean Anderson,
                Linda Essery, Byul Ha, Bella Horton, Han Bit Kang, Hamza Kasumba,
                Jolie Kemp, Jacob Maguire, Sean McOsker, Katie Owens,
                Ian Reed, Katie Shi, Julie Snodgrass, Sarah Solomon,
                Valerie Truong
              </p>
            </div>
          </div>
        </div>

        <div className="textbox-info">
          <p id="name"> Digital Designers</p>
          <p id="stats">
            <span id="class-year">Class of 2019: </span> Nitasha Kochar
          </p>
          <p id="stats">
            <span id="class-year">Class of 2020: </span>Justin Luo, Yenny Dieguez, Catherine Zhao, Lauren Gray
          </p>
          <p id="stats">
            <span id="class-year">Class of 2021: </span>Varsha Iyer, Sarah Hong
          </p>
        </div>

        <div className="textbox-info" id="contributors-info">
          <div className="engineers">
            <p id="name-engineer">Software Engineers</p>
            <img id="dali-black-logo" src={require('../assets/images/dali-black-logo.png')} alt="DALI logo" />
          </div>

          <p id="stats">
            <span id="class-year">Class of 2019: </span>Ijemma Onwuzulike
          </p>
          <p id="stats">
            <span id="class-year">Class of 2020: </span>Brayan Lozano, Sofia Stanescu-Bellu
          </p>
          <p id="stats">
            <span id="class-year">Class of 2021: </span>Yakoob Khan, Faustino Cortina
          </p>
        </div>
      </div>
    );
  }

  references = () => {
    return (
      <div>
        <div className="textbox" id="references">
          <h1 className="textbox-heading" id="acknowledgements-heading"> Sources </h1>
        </div>

        <div className="textbox-info" id="sources">
          <li> Basic biographcial facts were currated through sources such as wikipedia and public congressional records.</li>
          <li> Special thanks and acknowledgement to the Rauner Special Collections Library at Dartmouth College. Peter Carini, College Archivist, and Phyllis Gilbert, Processing Specialist, were especially instrumental in assisting students in researching the Rauner Library Alumni files, which contain biographical information of Dartmouth alumni in the form of newspapers, the {'"Dartmouth Alumni Magazine"'}, class newsletters, and a multitude of other sources.</li>
          <li> Dartmouth Alumni Magazine.</li>
          <li> Jonathan Fox Worchester, ed., Memorial of the Class of 1827, Hanover, NH: Centennial Anniversary of the College, 1869.</li>
          <li> Childs, Francis Lane, A Dartmouth History Lesson for Freshman, Dartmouth Alumni Magazine, December, 1957.</li>
          <li> BSmith, Baxter Perry, The History of Dartmouth College: 1829-1884, Boston, Houghton, Osgood and company, 1878.</li>
          <li> Behrens, Richard K. {'"From the Connecticut Valley to the West Coast: The Role of Dartmouth College in the Building of the Nation." Historical New Hampshire 63.1 (2009): 45-68'}</li>
          <li> A Description of Dartmouth College (published in 1937; details history/description of the College)</li>
          <li>Dartmouth College,{'"Rollins Chapel and Wilson Hall, Dartmouth College, June 25, 1884,"'} Hanover, N.H., Dartmouth Steam Press, 1884.</li>
          <li>Dartmouth College, {'"Centennial Celebration at Dartmouth College, July 21, 1869."'} Hanover, N.H. : J.B. Parker, 1870.</li>
          <li>Waterhouse, Stephen L., {'Dartmouth\'s dedicated alumni : fifty years of alumni awards, 1954-2004, with a brief sketch of earlier important figures and a history of Dartmouth College since the days of Eleazar Wheelock / Stephen L. Waterhouse. Stephen L. Waterhouse, Copyright 2004.'}</li>
          <li>Chapman, George T. Sketches of the Alumni of Dartmouth College. Cambridge, Printed at the Riverside Press, 1867.</li>
          <li>Blough, Barbara; Dana Cook Grossman. {'"Two Hundred Years of Medicine at Dartmouth"'}. Dartmouth Medical School.</li>
          <li>Scott A. Silverstone (2004). Divided Union: The Politics of War in the Early American Republic. Cornell University Press. p. {95}. ISBN 0801442303.</li>
          <li>Putnam, Constane E.,{'"The Science We Have Loved and Taught: Dartmouth Medical School\'s First Two Centuries."'}</li>
          <li>ProQuest Congressional.</li>
          <li>Govtrack.</li>
          <li>Congressional Record, Bound Addition.</li>
          <li>National Archives.</li>
          <li>History, Art, and Archives of the House of Representatives.</li>
          <li>Rutgers Center on the American Governor.</li>
          <li>The National Governors Association.</li>
          <li>C-SPAN video library (1987 - present).</li>
        </div>

        <div className="capitol-hill">
          <img id="capitol-hill" src={require('../assets/images/capitol-hill.png')} alt="Capitol-Hill" />
        </div>
      </div>
    );
  }

  checkdesktop() {
    if (window.innerWidth >= this.state.minimumdesktop) {
      this.setState({
        desktop: true,
      });
    } else {
      this.setState({
        desktop: false,
      });
    }
  }

  render() {
    if (this.state.desktop) {
      return (
        <div>
          <Header />
          <div className="page">
            <div className="contributors-background">
              {this.about()}
              {this.acknowledgements()}
              {this.contributors()}
              {this.references()}
            </div>
          </div>
          <Footer />
        </div>
      );
    } else {
      return (
        <MobilePage />
      );
    }
  }
}

export default withRouter(Contributors);



// WEBPACK FOOTER //
// ./src/pages/contributors.js